(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpDatatableSimple', cpDatatableSimple);

    cpDatatableSimple.$inject = ['$filter', 'datatableDefaultEmptyValueConst'];

    function cpDatatableSimple($filter, datatableDefaultEmptyValueConst) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                title: '@?',
                hideOrderCol: '@',
                hideActionsCol: '@',
                showOnlyExtraActions: '=?',
                loading: '=?',
                cols: '=',
                rows: '=',

                onClick: '&?',
                extraActions: '=?',
                contextMenuActions: '=?',

                logsInfo: '=',
            },
            templateUrl: 'app/caffeprint/directives/datatable-simple/datatable-simple.html',
            link: function(scope, element, attrs) {
                // data for getting col values
                scope.defaultEmptyString = datatableDefaultEmptyValueConst;
                scope.getValue = getValue;
                scope.getTextValue = getTextValue;
                scope.getBooleanValueClass = getBooleanValueClass;
                scope.getDecimalValue = getDecimalValue;
                scope.getJoinedValue = getJoinedValue;
                scope.getImageValue = getImageValue;
                scope.getListValue = getListValue;
                scope.isText = isText;
                scope.isBoolean = isBoolean;
                scope.isDecimal = isDecimal;
                scope.isImage = isImage;
                scope.isJoin = isJoin;
                scope.isList = isList;

                // data wuth templates paths
                scope.staticRow = 'app/caffeprint/directives/datatable-simple/datatable-simple-static-row.html';

                // data for checking what buttons should be displayed
                scope.isShowActionCol = isShowActionCol;

                function getValue(obj, key) {
                    return key.split(".").reduce(function(result, key) {
                        return result && result[key] ? result[key] : '';
                    }, obj);
                }

                function getTextValue(obj, key) {
                    return getValue(obj, key) || scope.defaultEmptyString;
                }

                function getBooleanValueClass(obj, key) {
                    if (getValue(obj, key)) {
                        return 'fa fa-check text-navy';
                    } else {
                        return 'fa fa-times text-danger';
                    }
                }

                function getDecimalValue(obj, key) {
                    var value = getValue(obj, key);
                    if (value) {
                        return $filter('number')(value, 2);
                    } else {
                        return scope.defaultEmptyString;
                    }
                }

                function getJoinedValue(obj, keys, separator) {
                    return keys.split('&').map(function(key) {
                        return getValue(obj, key);
                    }).filter(function(key) {
                        return !!key;
                    }).join(separator) || scope.defaultEmptyString;
                }

                function getImageValue(obj, key) {
                    return getValue(obj, key) || null;
                }

                function getListValue(obj, key) {
                    return getValue(obj, key) || [];
                }

                function isText(column) {
                    return column.type === "text" ||
                        column.type === "number" ||
                        column.type === "date" ||
                        column.type === "datetime" ||
                        column.type === undefined;
                }

                function isBoolean(column) {
                    return column.type === "boolean";
                }

                function isDecimal(column) {
                    return column.type === "decimal";
                }

                function isImage(column) {
                    return column.type === "image";
                }

                function isJoin(column) {
                    return column.type === "join";
                }

                function isList(column) {
                    return column.type === "list";
                }

                function isShowActionCol() {
                    return scope.showOnlyExtraActions || (!scope.hideActionsCol && (
                               scope.logsInfo ||
                               scope.extraActions));
                }
            }
        };
    }
})();
